export const documentPosition = ["Lokasi", "Region", "Subholding"];
